var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, ElementRef, Renderer } from '@angular/core';
var HeaderBgColorDirective = /** @class */ (function () {
    function HeaderBgColorDirective(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.setColor();
    }
    HeaderBgColorDirective.prototype.setColor = function () {
        var background_color = '#4e8ef7';
        if (localStorage.getItem('header_data') && localStorage.getItem('header_data') != '') {
            var header_data = JSON.parse(localStorage.getItem('header_data'));
            if (header_data['background_color']) {
                background_color = header_data['background_color'];
            }
        }
        this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', background_color);
    };
    HeaderBgColorDirective = __decorate([
        Directive({
            selector: '[header-bg-color]'
        }),
        __metadata("design:paramtypes", [ElementRef,
            Renderer])
    ], HeaderBgColorDirective);
    return HeaderBgColorDirective;
}());
export { HeaderBgColorDirective };
//# sourceMappingURL=header-bg-color.js.map


// WEBPACK FOOTER //
// ./src/directives/header-bg-color/header-bg-color.ts.pre-build-optimizer.js